export const validateYup = (schema, data) => {
	let isValid = true;
	let errors = {};
	try {
		schema.validateSync(data, {abortEarly: false});
	} catch (err) {
		isValid = false;

		if (err.inner && Array.isArray(err.inner)) {
			err.inner.forEach((e) => {
				if (e.path && !errors[e.path]) {
					errors[e.path.replace('[', '').replace(']', '')] = e.message;
				}
			});
		}
	}

	return {isValid, errors};
};
